// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + chunkId + "." + "d06f502d93b960c1532509c4723b0c44" + ".js";
};